export function validatePasswordInputs(oldPassword, newPassword, confirmed) {
    if (oldPassword == '') {
        return 'Please enter your old password.';
    }
    if (newPassword == '') {
        return 'Please enter your new password.';
    }
    if (confirmed != newPassword) {
        return 'Password and confirmed password must be the same.';
    }

    return validatePassword(newPassword);
}

export function validatePassword(password) {
    if (password.length < 8) {
        return 'Password must be at least 8 characters.';
    }
    let hasLowerCase = !!password.match(/[a-z]/);
    let hasUpperCase = !!password.match(/[A-Z]/);
    let hasNumber = !!password.match(/[0-9]/);
    let hasSymbol = !!password.match(/[$-/:-?{-~!"^_`\[\]]/);

    if (hasLowerCase + hasUpperCase + hasNumber + hasSymbol >= 3) {
        return;
    }

    // Not technically true, but it's easier to understand this way.
    if (hasLowerCase && hasUpperCase) {
        return 'Password must contain at least one number or symbol.';
    }
    if (hasLowerCase && hasNumber) {
        return 'Password must contain at least one upper case letter or symbol.';
    }
    if (hasLowerCase && hasSymbol) {
        return 'Password must contain at least one upper case letter or number.';
    }
    return 'Password should contain at least three of: ' +
        'a lower case letter; an upper case number; a symbol or a number.'
}